/**
 * Messenger is enabled for all dev/stage/prod environments
 * @returns True, if enabled/visible. False, if disabled/hidden
 */
export const isMessengerEnabled = (): boolean => true;
